import styled from "styled-components";

export const TitleContainer = styled.div`
  & > textarea {
    padding-bottom: 3px;
  }
`;
